export default __webpack_public_path__ + "static/toallaBanner-821360242a758ecdbd5eb4c8f8a6bf62.png";